/* cache-bust: 1785283200 */
/**
 * <waiver-form> - annual group ride waiver.
 *
 * The legal text is NOT authored in Liquid. It is fetched from the Worker
 * (GET {proxy}/waiver-document) and rendered here, so the document the signer
 * reads is byte-identical to the one the Worker hashes into the signed record.
 * The hash the client saw is posted back and the Worker rejects the submission
 * with 409 if the document changed while the form was open.
 */
(function () {
  'use strict';

  if (customElements.get('waiver-form')) return;

  var MIN_SUBMIT_MS = 2000;
  var TURNSTILE_TIMEOUT_MS = 8000;
  var RETRY_429_DELAY_MS = 30000;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function ageFrom(dobStr) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dobStr)) return null;
    var dob = new Date(dobStr + 'T00:00:00Z');
    if (isNaN(dob.getTime())) return null;
    var now = new Date();
    var age = now.getUTCFullYear() - dob.getUTCFullYear();
    var m = now.getUTCMonth() - dob.getUTCMonth();
    if (m < 0 || (m === 0 && now.getUTCDate() < dob.getUTCDate())) age -= 1;
    return age;
  }

  class WaiverForm extends HTMLElement {
    constructor() { super(); }
  }

  WaiverForm.prototype.connectedCallback = function () {
    this.form = this.querySelector('form');
    this.successEl = this.querySelector('[data-form-success]');
    this.statusEl = this.querySelector('[data-form-status]');
    this.submitBtn = this.querySelector('button[type="submit"]');
    this.submitIdle = this.querySelector('[data-submit-idle]');
    this.submitLoading = this.querySelector('[data-submit-loading]');
    this.honeypot = this.querySelector('[name="company_website"]');
    this.turnstileEl = this.querySelector('.cf-turnstile');
    this.docEl = this.querySelector('[data-waiver-document]');
    this.affirmEl = this.querySelector('[data-waiver-affirmations]');
    this.guardianEl = this.querySelector('[data-guardian-fields]');
    this.dobInput = this.querySelector('[name="date_of_birth"]');
    this.metaEl = this.querySelector('[data-waiver-meta]');

    this.proxyEndpoint = this.dataset.proxyEndpoint || '/apps/forms';
    this.documentEndpoint = this.proxyEndpoint.replace(/\/+$/, '') + '/waiver-document';
    this.turnstileSiteKey = this.dataset.turnstileSiteKey || '';

    if (!this.form) return;

    this._firstFocusAt = 0;
    this._submitting = false;
    this._turnstileWidgetId = null;
    this._turnstileResolve = null;
    this._doc = null;

    this.form.addEventListener('focusin', this._onFirstFocus.bind(this), { once: true });
    this.form.addEventListener('submit', this._onSubmit.bind(this));
    this.form.addEventListener('input', this._clearFieldError.bind(this));
    if (this.dobInput) this.dobInput.addEventListener('change', this._onDobChange.bind(this));

    this._setSubmitting(true);
    this._loadDocument();

    if (this.turnstileSiteKey && this.turnstileEl) this._initTurnstile();
  };

  WaiverForm.prototype._onFirstFocus = function () {
    this._firstFocusAt = Date.now();
  };

  WaiverForm.prototype._loadDocument = function () {
    var self = this;
    fetch(this.documentEndpoint, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (doc) {
        if (!doc || !doc.ok || !doc.sections) throw new Error('bad_document');
        self._doc = doc;
        self._renderDocument(doc);
        self._setSubmitting(false);
        self._setStatus('');
      })
      .catch(function () {
        self._setStatus('We could not load the waiver right now. Please refresh the page or call the shop.', 'error');
        self._setSubmitting(true);
      });
  };

  WaiverForm.prototype._renderDocument = function (doc) {
    if (this.docEl) {
      this.docEl.innerHTML = '';
      var h = el('h3', 'waiver-form__doc-title', doc.title);
      this.docEl.appendChild(h);
      for (var i = 0; i < doc.sections.length; i++) {
        this.docEl.appendChild(el('h4', 'waiver-form__doc-heading', doc.sections[i].heading));
        this.docEl.appendChild(el('p', 'waiver-form__doc-body', doc.sections[i].body));
      }
    }

    if (this.metaEl) {
      this.metaEl.textContent = 'Version ' + doc.version + ', effective ' + doc.effective_date +
        '. Valid for ' + doc.term_days + ' days from signing.';
    }

    if (this.affirmEl) {
      this.affirmEl.innerHTML = '';
      for (var j = 0; j < doc.affirmations.length; j++) {
        var a = doc.affirmations[j];
        var wrap = el('div', 'waiver-form__check' + (a.required ? '' : ' waiver-form__check--optional'));
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.name = a.key;
        input.value = 'yes';
        input.id = 'WaiverForm-' + a.key;
        input.className = 'waiver-form__checkbox';
        var label = document.createElement('label');
        label.setAttribute('for', input.id);
        label.className = 'waiver-form__check-label body-small';
        label.textContent = a.label;
        wrap.appendChild(input);
        wrap.appendChild(label);
        this.affirmEl.appendChild(wrap);
      }
    }

    var vInput = this.form.querySelector('[name="waiver_sha256"]');
    if (vInput) vInput.value = doc.sha256;
    var verInput = this.form.querySelector('[name="waiver_version_seen"]');
    if (verInput) verInput.value = doc.version;
  };

  WaiverForm.prototype._onDobChange = function () {
    if (!this.guardianEl || !this.dobInput) return;
    var age = ageFrom(this.dobInput.value);
    var minor = age != null && age >= 0 && age < 18;
    this.guardianEl.hidden = !minor;
    var inputs = this.guardianEl.querySelectorAll('input');
    for (var i = 0; i < inputs.length; i++) {
      if (!minor) inputs[i].value = '';
    }
  };

  WaiverForm.prototype._setStatus = function (message, kind) {
    if (!this.statusEl) return;
    this.statusEl.textContent = message || '';
    this.statusEl.dataset.kind = kind || '';
  };

  WaiverForm.prototype._clearFieldError = function (e) {
    var t = e.target;
    if (!t || !t.name) return;
    if (t.getAttribute('aria-invalid') === 'true') {
      t.setAttribute('aria-invalid', 'false');
      t.removeAttribute('aria-describedby');
      var err = this.form.querySelector('[data-field-error-for="' + t.name + '"]');
      if (err) err.remove();
    }
  };

  WaiverForm.prototype._fieldError = function (name, message) {
    var input = this.form.querySelector('[name="' + name + '"]');
    if (!input) return;
    var id = 'WaiverForm-err-' + name + '-' + Math.random().toString(36).slice(2, 8);
    input.setAttribute('aria-invalid', 'true');
    input.setAttribute('aria-describedby', id);
    var err = el('div', 'waiver-form__field-error body-small', message);
    err.id = id;
    err.setAttribute('data-field-error-for', name);
    (input.parentNode || this.form).appendChild(err);
  };

  WaiverForm.prototype._setSubmitting = function (on) {
    this._submitting = !!on;
    if (this.submitBtn) this.submitBtn.disabled = !!on;
    if (this.submitIdle) this.submitIdle.hidden = !!on;
    if (this.submitLoading) this.submitLoading.hidden = !on;
  };

  WaiverForm.prototype._initTurnstile = function () {
    var self = this;
    function render() {
      if (window.turnstile && self.turnstileEl && self._turnstileWidgetId == null) {
        try {
          self._turnstileWidgetId = window.turnstile.render(self.turnstileEl, {
            sitekey: self.turnstileSiteKey,
            size: 'invisible',
            callback: function (token) {
              if (self._turnstileResolve) { self._turnstileResolve(token); self._turnstileResolve = null; }
            },
            'error-callback': function () {
              if (self._turnstileResolve) { self._turnstileResolve(''); self._turnstileResolve = null; }
            },
            'expired-callback': function () {
              if (self._turnstileWidgetId != null) { try { window.turnstile.reset(self._turnstileWidgetId); } catch (e) {} }
            }
          });
        } catch (e) {}
      } else if (self._turnstileWidgetId == null) {
        setTimeout(render, 200);
      }
    }
    render();
  };

  WaiverForm.prototype._getTurnstileToken = function () {
    var self = this;
    if (!this.turnstileSiteKey || !window.turnstile || this._turnstileWidgetId == null) {
      return Promise.resolve('');
    }
    var existing = '';
    try { existing = window.turnstile.getResponse(this._turnstileWidgetId) || ''; } catch (e) {}
    if (existing) return Promise.resolve(existing);
    return new Promise(function (resolve) {
      self._turnstileResolve = resolve;
      try { window.turnstile.execute(self._turnstileWidgetId); } catch (e) { resolve(''); self._turnstileResolve = null; return; }
      setTimeout(function () {
        if (self._turnstileResolve) { self._turnstileResolve(''); self._turnstileResolve = null; }
      }, TURNSTILE_TIMEOUT_MS);
    });
  };

  WaiverForm.prototype._resetTurnstile = function () {
    if (this._turnstileWidgetId != null && window.turnstile) {
      try { window.turnstile.reset(this._turnstileWidgetId); } catch (e) {}
    }
  };

  WaiverForm.prototype._validate = function (fd) {
    var ok = true;
    var self = this;
    function req(name, msg) {
      var v = (fd.get(name) || '').trim();
      if (!v) { self._fieldError(name, msg); ok = false; return false; }
      return true;
    }

    req('first_name', 'Please enter your first name.');
    req('last_name', 'Please enter your last name.');

    var email = (fd.get('email') || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      this._fieldError('email', 'Please enter a valid email address.'); ok = false;
    }

    var phone = (fd.get('phone_number') || '').trim();
    if (!phone || phone.replace(/\D/g, '').length < 10) {
      this._fieldError('phone_number', 'Please enter a valid phone number.'); ok = false;
    }

    var dob = (fd.get('date_of_birth') || '').trim();
    var age = ageFrom(dob);
    if (age == null || age < 0 || age > 120) {
      this._fieldError('date_of_birth', 'Please enter a valid date of birth.'); ok = false;
    }

    req('emergency_contact_name', 'Please give us an emergency contact.');
    req('emergency_contact_phone', 'Please give us an emergency contact phone number.');
    req('typed_signature', 'Type your full legal name to sign.');

    if (age != null && age < 18) {
      req('guardian_name', 'A parent or guardian must be named.');
      req('guardian_relationship', 'Please state the relationship.');
      req('guardian_signature', 'A parent or guardian must sign.');
    }

    if (this._doc && this._doc.affirmations) {
      for (var i = 0; i < this._doc.affirmations.length; i++) {
        var a = this._doc.affirmations[i];
        if (!a.required) continue;
        if (!fd.get(a.key)) {
          var box = this.form.querySelector('[name="' + a.key + '"]');
          if (box) {
            box.setAttribute('aria-invalid', 'true');
            var holder = box.closest('.waiver-form__check');
            if (holder && !holder.querySelector('[data-field-error-for="' + a.key + '"]')) {
              var e2 = el('div', 'waiver-form__field-error body-small', 'You must agree to continue.');
              e2.setAttribute('data-field-error-for', a.key);
              holder.appendChild(e2);
            }
          }
          ok = false;
        }
      }
    }

    return ok;
  };

  WaiverForm.prototype._showSuccess = function (body) {
    if (!this.successEl || !this.form) return;
    this.form.hidden = true;
    this.successEl.hidden = false;
    var exp = this.successEl.querySelector('[data-waiver-expiry]');
    if (exp && body && body.expires_at) {
      try {
        exp.textContent = new Date(body.expires_at).toLocaleDateString('en-US', {
          year: 'numeric', month: 'long', day: 'numeric'
        });
      } catch (e) {}
    }
    this._setStatus('');
    try { this.successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
  };

  WaiverForm.prototype._applyServerErrors = function (fields) {
    if (!fields || typeof fields !== 'object') return;
    var labels = {
      first_name: 'Please enter your first name.',
      last_name: 'Please enter your last name.',
      email: 'Please enter a valid email address.',
      phone_number: 'Please enter a valid phone number.',
      date_of_birth: 'Please enter a valid date of birth.',
      emergency_contact_name: 'Please give us an emergency contact.',
      emergency_contact_phone: 'Please give us an emergency contact phone number.',
      typed_signature: 'Type your full legal name to sign.',
      guardian_name: 'A parent or guardian must be named.',
      guardian_relationship: 'Please state the relationship.',
      guardian_signature: 'A parent or guardian must sign.'
    };
    for (var name in fields) {
      if (!Object.prototype.hasOwnProperty.call(fields, name)) continue;
      this._fieldError(name, labels[name] || 'You must agree to continue.');
    }
  };

  WaiverForm.prototype._onSubmit = function (e) {
    e.preventDefault();
    if (this._submitting) return;
    if (this.honeypot && this.honeypot.value) return;
    if (!this._doc) {
      this._setStatus('The waiver is still loading. Please wait a moment and try again.', 'error');
      return;
    }

    var prior = this.form.querySelectorAll('.waiver-form__field-error');
    for (var p = 0; p < prior.length; p++) prior[p].remove();
    var invalids = this.form.querySelectorAll('[aria-invalid="true"]');
    for (var q = 0; q < invalids.length; q++) invalids[q].setAttribute('aria-invalid', 'false');

    var fd = new FormData(this.form);
    if (!this._validate(fd)) {
      this._setStatus('Please correct the errors above.', 'error');
      var firstErr = this.form.querySelector('[aria-invalid="true"]');
      if (firstErr) firstErr.focus();
      return;
    }

    var elapsed = this._firstFocusAt ? (Date.now() - this._firstFocusAt) : 0;
    if (elapsed > 0 && elapsed < MIN_SUBMIT_MS) return;

    var self = this;
    this._setSubmitting(true);
    this._setStatus('');

    this._getTurnstileToken().then(function (token) {
      if (self.turnstileSiteKey && !token) {
        self._setStatus('Could not verify you are human. Please try again.', 'error');
        self._setSubmitting(false);
        return;
      }
      if (token) fd.set('cf_turnstile_response', token);

      return fetch(self.proxyEndpoint, {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) {
          return { res: res, body: body };
        });
      }).then(function (out) {
        var res = out.res;
        var body = out.body || {};

        if (res.status === 200 && body.ok) {
          self._showSuccess(body);
          return;
        }
        if (res.status === 409 && body.error === 'waiver_version_changed') {
          self._setStatus('Our waiver was updated while this page was open. We have reloaded the latest version, please review and sign again.', 'error');
          self._loadDocument();
          self._resetTurnstile();
          return;
        }
        if (res.status === 400 && body.error === 'validation_failed') {
          self._applyServerErrors(body.fields);
          self._setStatus('Please review the highlighted fields and try again.', 'error');
          var fe = self.form.querySelector('[aria-invalid="true"]');
          if (fe) fe.focus();
          self._resetTurnstile();
          return;
        }
        if (res.status === 400 && body.error === 'captcha_failed') {
          self._setStatus('Could not verify you are human. Please try again.', 'error');
          self._resetTurnstile();
          return;
        }
        if (res.status === 429) {
          self._setStatus('Too many attempts just now. Please try again in a moment.', 'error');
          if (self.submitBtn) {
            self.submitBtn.disabled = true;
            setTimeout(function () { if (self.submitBtn) self.submitBtn.disabled = false; }, RETRY_429_DELAY_MS);
          }
          self._resetTurnstile();
          return;
        }
        if (res.status === 503 && body.error === 'waiver_not_recorded') {
          self._setStatus('We could not record your waiver just now, so it has not been saved. Please try again or sign at the shop.', 'error');
          self._resetTurnstile();
          return;
        }
        if (res.status >= 500) {
          self._setStatus('Something went wrong on our end. Please try again or call the shop.', 'error');
          self._resetTurnstile();
          return;
        }
        self._setStatus('We could not submit your waiver. Please review your info and try again.', 'error');
        self._resetTurnstile();
      });
    }).catch(function () {
      self._setStatus('Network error. Please try again or call the shop.', 'error');
      self._resetTurnstile();
    }).finally(function () {
      self._setSubmitting(false);
    });
  };

  customElements.define('waiver-form', WaiverForm);
})();
